exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#div_publication[data-v-07ac7872]{margin:15px auto;padding-left:10px;border-left:2px solid #eee}.single-paper[data-v-07ac7872]{padding:10px;margin:10px 0;box-sizing:border-box;background:#f2f2f2;border-radius:8px 8px 8px 8px}.single-paper[data-v-07ac7872]:after{content:\" \";display:block;clear:both}.p_keytag[data-v-07ac7872]{font-weight:700;font-size:20px}.p_title[data-v-07ac7872]{color:#b00}.p_vennue[data-v-07ac7872]{font-style:italic}.p_award[data-v-07ac7872]{font-weight:700;color:red}#div_bib[data-v-07ac7872]{width:79%;float:left}#div_img[data-v-07ac7872]{width:20%;float:right}.img_publication[data-v-07ac7872]{width:100%;padding:1px;border:0 solid #021a40}.link_data[data-v-07ac7872]{text-decoration:none}.img_icon[data-v-07ac7872]{width:22px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-07ac7872","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/publication.vue
// module id = 221
// module chunks = 0